<template>
  <div>
    <div id="vContents">
      <div id="cNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/Social/forum'}">青博讲堂</router-link>
      </div>
      <div id="vtitle">青博名家讲堂报名表</div>
      <div id="volhr"></div>
      <div id="addvolun">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="联系人" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="参加人" prop="cjname">
            <el-input v-model="addForm.cjname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="cardID">
            <el-input v-model="addForm.cardID" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="addForm.title" auto-complete="off" disabled="disabled">{{addForm.title}}</el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="info">
            <el-input v-model="addForm.info" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </div>
      <div id="volhrbottom"></div>
      <div style="text-align: left;margin-top: 30px;color: red;">
        <p>温馨提示：</p><br />
        <p class="ql-align-justify">1、开讲前半小时到场，配合入场登记工作，有序入场。</p><br />
        <p class="ql-align-justify">2、为避免影响他人听讲，讲座期间请将手机置于无声或震动状态。</p><br />
        <p class="ql-align-justify">3、讲座期间请勿大声喧哗，携带儿童的家长请照顾好您的小孩。</p><br />
        <p style="padding-top: 1.25rem;">报名须知：</p><br />
        <p class="ql-align-justify">报名需如实填写参与者姓名、身份证及手机号。当天凭入场券或身份证号签到入场。
          如您不能按时参加活动，请在报名截止日期前至青海省博物馆大厅或官网预约。如无法完成网上活动预约报名，请持有效证件（护照、台胞证等）前往博物馆大厅问讯处报名领票。</p>
      </div>
      <div style="clear: both;padding-bottom: 1.875rem;" ></div>
    </div>
    <div id="mvContents">
      <div id="mcNav">
        <router-link tag="span" :to="{path:'/Homepage'}">首页</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link tag="span"
          :to="{path:'/Social/forum'}">青博讲堂</router-link>
      </div>
      <div id="mvtitle">青博名家讲堂报名表</div>
      <div id="mvolhr"></div>
      <div id="maddvolun">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="联系人" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="参加人" prop="cjname">
            <el-input v-model="addForm.cjname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="addForm.phone" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="cardID">
            <el-input v-model="addForm.cardID" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="活动名称" prop="title">
            <el-input v-model="addForm.title" auto-complete="off" disabled="disabled">{{addForm.title}}</el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="info">
            <el-input v-model="addForm.info" auto-complete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </div>
      <div id="mvolhrbottom"></div>
      <div style="text-align: left;margin: 30px 0;color: red;">
        <p>温馨提示：</p><br />
        <p class="ql-align-justify">1、开讲前半小时到场，配合入场登记工作，有序入场。</p><br />
        <p class="ql-align-justify">2、为避免影响他人听讲，讲座期间请将手机置于无声或震动状态。</p><br />
        <p class="ql-align-justify">3、讲座期间请勿大声喧哗，携带儿童的家长请照顾好您的小孩。</p><br />
        <p style="padding-top: 1.25rem;">报名须知：</p><br />
        <p class="ql-align-justify">报名需如实填写参与者姓名、身份证及手机号。当天凭入场券或身份证号签到入场。
          如您不能按时参加活动，请在报名截止日期前至青海省博物馆大厅或官网预约。如无法完成网上活动预约报名，请持有效证件（护照、台胞证等）前往博物馆大厅问讯处报名领票。</p>
      </div>
      <div style="clear: both;"></div>
    </div>
  </div>

</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        // 新增相关数据
        addFormVisible: true, // 新增页面是否开启
        addLoading: false,
        addForm: {
          name: '',
          cjname: '',
          cardID: '',
          title: this.$route.query.title,
          info: '',
          phone: '',
          forumid: this.$route.query.id,
          hid: this.$route.query.id

        },
        addFormRules: {
          name: [{
            required: true,
            message: '请输入联系人姓名',
            trigger: 'blur'
          }],
          cjname: [{
            required: true,
            message: '请输入参加人姓名',
            trigger: 'blur'
          }],
          cardID: [{
            required: true,
            message: '请输入身份证号',
            trigger: 'blur'
          }],
          title: [{
            required: true,
            message: '请输入活动名称',
            trigger: 'blur'
          }],
          info: [{
            required: true,
            message: '请输入备注信息',
            trigger: 'blur'
          }],
          phone: [{
            required: true,
            message: '请输入联系人电话',
            trigger: 'blur'
          }]
        }
      }
    },
    mounted() {
      if (location.href.indexOf("#reloaded") == -1) {
        location.href = location.href + "#reloaded";
        location.reload();
      };
      if (this.isMobile()) {
        document.getElementById("vContents").style.display = "none"
      } else {
        document.getElementById("mvContents").style.display = "none";
        document.getElementById("vContents").style.display = "block"
      }
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      showAddDialog: function() {
        this.addForm = {
          name: '',
          cjname: '',
          cardID: '',
          title: this.$route.query.title,
          info: '',
          phone: '',
          forumid: this.$route.query.id,
          hid: this.$route.query.id
        }
      },
      // 新增数据
      addSubmit: function() {
        let that = this;
        let url = this.HOST + '/api/v1/social/newlyLectureBm';
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            that.loading = true;
            let para = Object.assign({}, this.addForm);
            that.$axios.post(url, para).then(function(result) {
              that.loading = false;
              if (result.data && result.data.code === 0) {
                that.$message.success({
                  showClose: true,
                  message: '活动预约报名已提交成功',
                  duration: 2000
                });
                that.$refs['addForm'].resetFields();
                that.addFormVisible = false;
                that.$router.push({
                  path: '/Social/forum'
                });
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.data && result.data.message ? result.data.message : '活动预约报名提交失败',
                  duration: 2000
                });
              }
            }, function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }).catch(function(error) {
              console.log(error)
            })
          }
        })
      }
    }
  }
</script>

<style>
  #vContents {
    display: none;
    width: 80%;
    margin: 0 10%;
  }

  #addvolun {
    width: 60%;
    margin: 10px 20%;

  }

  #volhr,
  #volhrbottom {
    width: 100%;
    height: 1px;
    border-bottom: 1px dotted #dbdbdb;
    float: left;
  }

  #vtitle {
    height: 60px;
    line-height: 60px;
  }

  .el-form-item__content {
    text-align: left;
    margin-left: 100px;
  }

  .el-radio+.el-radio {
    margin-left: 20px;
  }

  #cNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #cNav>span:nth-child(1),
  #cNav>span:nth-child(2) {
    cursor: pointer;
  }

  #cNav>span:nth-child(1):hover,
  #cNav>span:nth-child(2):hover {
    color: #FF9900;
  }

  /*mobile*/
  #mvContents {
    margin: 0 10px;
  }

  #maddvolun {
    width: 100%;
    margin-top: 10px;
  }

  #mvolhr,
  #mvolhrbottom {
    width: 100%;
    height: 1px;
    border-bottom: 1px dotted #dbdbdb;
    float: left;
  }

  #mvtitle {
    height: 60px;
    line-height: 60px;
  }

  .el-form-item__content {
    text-align: left;
    margin-left: 100px;
  }

  .el-radio+.el-radio {
    margin-left: 20px;
  }

  #mcNav {
    text-align: left;
    height: 48px;
    line-height: 48px;
  }

  #mcNav>span:nth-child(1),
  #mcNav>span:nth-child(2) {
    cursor: pointer;
  }

  #mcNav>span:nth-child(1):hover,
  #mcNav>span:nth-child(2):hover {
    color: #FF9900;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Social/forumbm.vue